export default __webpack_public_path__ + "static/media/franchini.f3219e1d.jpg";